import React, { Component } from 'react';
import axios from 'axios';
import {API_URL,BASE_URL_RECURSOS} from '../../constants';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import Moment from 'moment';
import OtrosSectores from '../partials/otros-sectores';

import {formatLimitString} from '../../functions';

export default class Noticias extends Component {

    constructor(props) {
        super(props);

        this.state = {
            resource: [],
            response: [],
            firstOrDefault: [],
            error: [],
            key: 0,
            clave: this.props.clave,
            title: this.props.titulo,
            hasNews: false,
            hasInitialNew: false,
            security: JSON.parse(localStorage.getItem('userBulletin'))
          }
      }


    componentDidMount() {

        this.setState({ hasNews:false });

        var code = 'NOTI';
        var key = this.props.clave;
        var url = `${API_URL}BulletinResourceUX/${key}/${code}/`;
        axios.get(url).then(response => response.data)
        .then((data) => {

            data.result = data.result.filter(item => item.cRec_Id===40);

            if (data.result.length>0)
            {

                var initialNews = data.result.filter(item => item.bPortada);
                var otherNews = data.result.filter(item => !item.bPortada);

                if (initialNews===undefined || initialNews.length===0)
                {
                    this.setState({ resource: otherNews.slice(1,otherNews.length), firstOrDefault: otherNews[0], hasNews:true, hasInitialNew: true });
                }  else
                {
                    this.setState({ resource: otherNews, firstOrDefault: initialNews[0], hasNews:true, hasInitialNew: true });
                }
            }
            else
            {
                this.setState({ resource: [], firstOrDefault: [], hasNews:false, hasInitialNew: false });
            }

            document.getElementById('loaderNews').classList.add('loader--hide');
            document.getElementById('contentNews').removeAttribute("hidden");
        })
        .catch(error => {
        });

    }

    render() {

        Moment.updateLocale('en', {
            months : [
                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
                "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"
            ]
        });

        Moment.updateLocale('en', {
            weekdays : [
                "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"
            ]
        });
        
        return (

        
            <div className="last-news-sector gray-bg">
                <div className="boletin__section ">
                    <div className="row" >
                        <div className="col-sm-12">
                        <ul id="boletin__header-title">
                            <li className="boletin__subtitle-name ">
                                <span className="boletin__subtitle-name--pl">{this.state.title}</span>
                            </li>
                        </ul>
                        </div>
                    </div>
                    <div className="loader" id="loaderNews"></div>
                    <div className="row last-news-sector__row"  id="contentNews" >
                        <div className="last-news-sector__main col-sm-6">
                            {((this.state.hasNews)?(
                            <Link to={'/' + this.props.clave + '/' + this.state.firstOrDefault.nRecursoCodigo} className="new-opportunity__more-info-link">
                            <div className={"imagenNoticia--" + this.props.clase + " last-news-sector__main-item--"+this.props.clase} style={{backgroundImage: "url('" + BASE_URL_RECURSOS + this.state.firstOrDefault.sFondo + "')"}}>
                                <div className="">
                                        <p className={"last-news__category last-news__category--" + this.props.clase}>NOTAS </p>
                                        <p className="last-news__title"> {this.state.firstOrDefault.sTituloRecurso}</p>
                                        <p className="last-news__extract"> {formatLimitString(this.state.firstOrDefault.sResumenRecurso, 110)}</p>
                                    <p className="last-news__more-info">
                                    <span className="last-news__more-info-date">{Moment(this.state.resource.dFechaPublicacionRecurso).format('DD/MM/YYYY')}</span>
                                            <span className="last-news__more-info-arrow"><i className="fas fa-chevron-right"></i></span>
                                    </p>
                                </div>
                            </div>
                            </Link>
                            ):(<div><strong >No hay una noticia principal</strong></div>))}
                        </div>
                        <div className="col-sm-6">
                            <div className="row" >
                            {
                                this.state.resource.map((resource, index) => (
                                   
                                    <div className="last-news-sector__secundary col-sm-6" key={resource.nBoletinRecursoCodigo}>
                                        <Link to={'/' + this.props.clave + '/' + resource.nRecursoCodigo } className="new-opportunity__more-info-link">
                                        <div className="imagenNoticiaSecundaria last-news-sector__secundary-item" style={{backgroundImage: "url('" + BASE_URL_RECURSOS + resource.sFondo + "')", backgroundSize: "cover", backgroundRepeat: "no-repeat"}}>
                                            <p className={"last-news__category last-news__category--"+this.props.clase}>NOTAS</p>
                                            <br/>
                                            <p className="last-news-sector__secundary-item-title"> {formatLimitString(resource.sTituloRecurso, 55)}</p>
                                            <p hidden={true} className="last-news-sector__secundary-item-extract"> {formatLimitString(resource.sResumenRecurso, 60)}</p>
                                            <p className="last-news-sector__more-info">
                                            
                                                <span className="last-news-sector__more-info-arrow">
                                                    <i className="fas fa-chevron-right"></i>
                                                </span>
                                            
                                            </p>
                                        </div>
                                        </Link>
                                    </div>
                                    
                                ))
                            }
                            </div>
                        </div>

                </div>
            </div>
        </div>
        )
    }

}
